import { render, staticRenderFns } from "./town-com.vue?vue&type=template&id=01413c01&"
import script from "./town-com.vue?vue&type=script&lang=js&"
export * from "./town-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports